import { useLocation } from 'react-router-dom';
import { useAppUpdateOnNavigate } from '@hooks/use-app-update';

/**
 * Moves the tab onto a newer build on the next page change, and ends the
 * extraction screen's deferral once the user has landed somewhere.
 *
 * Renders nothing. It exists only to be inside the router: AppUpdateModal is
 * mounted outside it and so cannot read the location.
 */
export default function AppUpdateNavigationWatcher() {
  useAppUpdateOnNavigate(useLocation().pathname);
  return null;
}
